/* global require, process */
/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Support component names relative to this directory:
import * as Sentry from '@sentry/browser';
import React from 'react';
import '../utils/disable-number-scroll';

if (!globalThis.webpackPublicPath) {
  alert('window.webpackPublicPath not defined');
}

// Set the base URL (asset host) for all webpack related requests. This is
// necessary for webpack to find images, sound files etc. This is used by
// file-loader. See config/webpack/production.js.
// https://webpack.js.org/guides/public-path/#on-the-fly
// eslint-disable-next-line no-undef
__webpack_public_path__ = globalThis.webpackPublicPath;

const production = process.env.NODE_ENV === 'production';

if (!production) {
  /* eslint-disable-next-line unicorn/prefer-module */
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, { trackAllPureComponents: true });
  /* eslint-disable-next-line unicorn/prefer-module */
  require('../utils/performance');
}

if (production) {
  // WARNING don't use `process.env.SENTRY_DSN_JS`, because this is statically
  // compiled and will be in the client code. Instead, use `globalThis` to
  // get the sentryDsnJs from application.html.haml
  Sentry.init({ dsn: globalThis.sentryDsnJs });
}

/* eslint-disable-next-line unicorn/prefer-module */
const componentRequireContext = require.context('components', true);
import ReactRailsUJS from 'react_ujs';

/* eslint-disable react-hooks/rules-of-hooks */
ReactRailsUJS.useContext(componentRequireContext);
